module.exports = __webpack_public_path__ + "img/iq_shad2.a36ba27a.png";